import { createReduxActionCreator } from '../types';
import { SystemPromptCategory } from './caregiverAssistantTypes';

export const CAREGIVER_ASSISTANT_ACTION_PREFIX = 'caregiver-assistant-redux/';

export const getSystemPromptCategoriesAction = createReduxActionCreator<SystemPromptCategory[]>(
  `${CAREGIVER_ASSISTANT_ACTION_PREFIX}get-system-prompt-categories`
);
